import React, { ReactElement } from 'react';
import { InfoOutlinedIcon, CloseIcon, Link } from 'elmo-elements';
import './AiCaveatNotice.scss';

export const AI_LEARN_MORE_URL = 'https://elmosoftware.com.au/ai-terms-conditions';

export const AI_CAVEAT_DEFAULT_COPY =
  'AI can make mistakes. Review the generated content for accuracy before you publish.';

interface AiCaveatNoticeProps {
  copy?: string;
  isDismissible?: boolean;
  onDismiss?: () => void;
  className?: string;
}

const AiCaveatNotice = ({
  copy = AI_CAVEAT_DEFAULT_COPY,
  isDismissible = false,
  onDismiss,
  className,
}: AiCaveatNoticeProps): ReactElement => (
  <div
    role="note"
    className={['ai-caveat-notice', className].filter(Boolean).join(' ')}
  >
    <span className="ai-caveat-notice__icon" aria-hidden="true">
      <InfoOutlinedIcon />
    </span>
    <span className="ai-caveat-notice__text">
      {copy}{' '}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link url={AI_LEARN_MORE_URL} newWindow className="ai-caveat-notice__link">
        Learn more
      </Link>
    </span>
    {isDismissible && (
      <button
        type="button"
        className="ai-caveat-notice__dismiss"
        aria-label="Dismiss notice"
        onClick={onDismiss}
      >
        <CloseIcon />
      </button>
    )}
  </div>
);

export default AiCaveatNotice;
